const guardModuleRoute = async(to, from, next) =>
{
    let moduleConfig = null;
    if (to.name === 'tutorial' && from.name !== 'tutorial')
    {
        // eslint-disable-next-line prefer-template
        moduleConfig = await import('@/components/slides/0/config');
    }
    else if (to.params.module !== from.params.module)
    {
        // eslint-disable-next-line prefer-template
        moduleConfig = await import('@/components/slides/' + to.params.module + '/config');
    }
    if (moduleConfig)
    {
        await require('@/main').default.loadCanvasBackgrounds(moduleConfig.default.backgrounds);
    }
    next();
};

export default guardModuleRoute;
